import { schema } from 'normalizr';
import { Space } from 'api/space/space';
// import { spaceTabSchema } from 'data/spaces';
import { taskSchema } from 'data/tasks/schema';

export const projectPhaseSchema = new schema.Entity(
  'projectPhases',
  { tasks: [taskSchema] },
  { idAttribute: 'projectPhaseId' },
);

// NOTE:: Customising it here since templates uses `spaceList` instead of `spaces`
const spaceSchema = new schema.Entity<Space>(
  'spaceList',
  {
    // spaceTabs: [spaceTabSchema],
  },
  {
    idAttribute: (value: Space) => String(value.spaceId),
    processStrategy: (entity: Space) => {
      return entity.spaceTabs ? { ...entity } : { ...entity, spaceTabs: [] };
    },
  },
);

export const templateSchema = new schema.Entity(
  'template',
  {
    templateContent: {
      projectPhases: [projectPhaseSchema],
      spaceList: [spaceSchema],
    },
  },
  {
    idAttribute: 'templateId',
  },
);
